import React from "react";
import styled from "styled-components";
//import {BrowserRouter as Router, Route, Switch, Link, Redirect} from 'react-router-dom'
//import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import {HashRouter} from 'react-router-dom';
import PlayersPage from "./Players/PlayersPage";
import Landing from "./Landing";
import { colors, mediaQueries } from "../shared/config"

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    background: ${colors.background};
    padding: 0.1em 0.1em 0 0;
    padding: 1% 5% 1% 5%;
    border-top: 1px solid #434343;
    border-bottom: 1px solid #434343;
    top: 0;
    justify-content: center;
    align-items: center;
    ${mediaQueries.mobile} {
        justify-content: space-around;
        height: 2rem;
    }
`;

const StyledLink = styled.a`
    color: white;
    text-decoration: none;
    font-family: Optima;
    margin-left: 1rem;
    margin-right: 1rem;
    ${mediaQueries.mobile} {
        margin: 0;
        font-size: 0.8em;
    }
`;


export default class Navbar extends React.Component{
    constructor(props) {
        super(props);
    }
    render() {
    return (
             
        <Wrapper>
        <HashRouter>
            <HashLink  to={"#women"}  style={{ textDecoration: 'none', color: 'black' }}>
                <StyledLink>
                WOMEN'S
                </StyledLink>
            </HashLink>
            <HashLink  to={"#men"}  style={{ textDecoration: 'none', color: 'black' }}>
                <StyledLink>
                MEN'S
                </StyledLink>
            </HashLink>
            <HashLink  to={"#stories"}  style={{ textDecoration: 'none', color: 'black' }}>
                <StyledLink>
                STORIES
                </StyledLink>
            </HashLink>
            <HashLink  to={"#galleries"}  style={{ textDecoration: 'none', color: 'black' }}>
                <StyledLink>
                GALLERIES
                </StyledLink>
            </HashLink>
            </HashRouter>
        </Wrapper>
        
    );
    }
};
